/* HILO · Tailor Fit page — style showcase.
   The line-art model's jacket follows the card at the top of the column:
   front, lapel, pockets, and a casual (chinos, open collar) or formal
   (suit, tie) look. Auto-advances; pauses on hover, when off screen, when
   the tab is hidden, and for visitors who prefer reduced motion. */
(function () {
  function init(root) {
    if (root.__tfShow) return;
    root.__tfShow = true;
    var strip = root.querySelector('[data-tf-strip]');
    if (!strip) return;
    var cards = Array.prototype.slice.call(strip.querySelectorAll('[data-tf-card]'));
    var seq = cards.filter(function (c) { return !c.hasAttribute('data-dup'); });
    var N = seq.length;
    var K = cards.length;
    if (!N) return;
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-layer]'));
    function q(sel) { return root.querySelector(sel); }
    var tTitle = q('[data-tf-title]'), tSub = q('[data-tf-sub]');
    var cLapel = q('[data-tf-lapel]'), cPocket = q('[data-tf-pocket]'), cFront = q('[data-tf-front]');
    var prog = q('[data-tf-prog]'), toggle = q('[data-tf-toggle]');
    var i = 0, s = 0, hover = false, visible = true, wrapT = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var playing = !reduce;

    function paint(anim) {
      var d = seq[i].dataset;
      var keys = ['f_' + d.f, 'l_' + d.f + '_' + d.lp, 'p_' + d.pk, d.cat === 'Formal' ? 'formal' : 'casual'];
      layers.forEach(function (g) {
        g.classList.toggle('is-on', keys.indexOf(g.getAttribute('data-layer')) > -1);
      });
      if (tTitle) tTitle.textContent = d.title;
      if (tSub) tSub.textContent = d.sub;
      if (cLapel) cLapel.textContent = d.lapel;
      if (cPocket) cPocket.textContent = d.pocket;
      if (cFront) cFront.textContent = d.front;
      if (prog) prog.style.width = ((i + 1) / N * 100).toFixed(2) + '%';
      strip.classList.toggle('no-anim', !anim);
      strip.style.transform = 'translateY(' + (-(s / K) * 100).toFixed(4) + '%)';
      if (!anim) void strip.offsetHeight;
      cards.forEach(function (c, k) {
        var b = c.querySelector('button');
        if (b) { if (k === s) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
        if (k >= s && k <= s + 2) {
          var img = c.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        }
      });
    }

    function go(dir) {
      clearTimeout(wrapT);
      if (dir > 0) {
        if (i === N - 1) {
          i = 0; s = N; paint(true);
          wrapT = setTimeout(function () { s = 0; paint(false); }, 700);
        } else { i += 1; s = i; paint(true); }
      } else if (i === 0) {
        s = N; paint(false);
        wrapT = setTimeout(function () { i = N - 1; s = N - 1; paint(true); }, 40);
      } else { i -= 1; s = i; paint(true); }
    }

    function setPlaying(v) {
      playing = v;
      root.classList.toggle('is-paused', !playing);
      if (toggle) {
        toggle.setAttribute('aria-label', playing ? 'Pause the style showcase' : 'Play the style showcase');
        toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      }
    }

    var prev = q('[data-tf-prev]'), next = q('[data-tf-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (toggle) toggle.addEventListener('click', function () { setPlaying(!playing); });
    cards.forEach(function (c) {
      var b = c.querySelector('button');
      if (!b) return;
      b.addEventListener('click', function () {
        clearTimeout(wrapT);
        i = parseInt(c.getAttribute('data-idx'), 10) || 0; s = i; paint(true);
      });
    });
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }
    root.__tfTimer = setInterval(function () {
      if (playing && !hover && visible && !document.hidden) go(1);
    }, 2800);
    setPlaying(playing);
    paint(false);
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tf-show]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-tf-show]'), function (r) { clearInterval(r.__tfTimer); });
  });
})();
